export * from './lib/text-fit.module';
